import { Skeleton, TableSkeleton } from '@/components/ui/Skeleton';

/** Compact placeholder while a settings master chunk loads — keeps page chrome stable. */
export function SettingsMasterSkeleton() {
  return (
    <div className="page-content w-full min-w-0 space-y-4" aria-busy="true" aria-live="polite">
      <div className="space-y-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <div className="card space-y-3 p-4">
        <Skeleton className="h-9 w-64 max-w-full" />
        <TableSkeleton rows={6} cols={4} />
      </div>
    </div>
  );
}
